import type { SVGProps } from 'react';

export type IconName =
  | 'home'
  | 'info'
  | 'news'
  | 'trophy'
  | 'document'
  | 'graduation'
  | 'briefcase'
  | 'building'
  | 'user'
  | 'chart'
  | 'calendar'
  | 'chat'
  | 'upload'
  | 'shield'
  | 'search';

const paths: Record<IconName, string> = {
  home: 'M3 11 12 4l9 7v9h-6v-6H9v6H3z',
  info: 'M12 10v7M12 7h.01',
  news: 'M4 5h16v14H4zM7 9h10M7 13h6M15 13h2M7 16h10',
  trophy: 'M8 4h8v4a4 4 0 0 1-8 0zM9 18h6M12 12v6',
  document: 'M5 4h14v16H5zM8 8h8M8 12h8M8 16h5',
  graduation: 'm3 9 9-5 9 5-9 5zM7 12v5c3 2 7 2 10 0v-5',
  briefcase: 'M4 7h16v12H4zM8 7V5h8v2M4 11h16',
  building: 'M4 21V7l8-4 8 4v14M8 10h2m4 0h2M8 14h2m4 0h2',
  user: 'M4 20c0-4 4-6 8-6s8 2 8 6',
  chart: 'M4 19V5m6 14V9m6 10V3',
  calendar: 'M4 5.5c3-.8 5.7-.3 8 1.5v12c-2.3-1.8-5-2.3-8-1.5z',
  chat: 'M8 12h8M12 8v8',
  upload: 'M12 4v12m0-12 4 4m-4-4-4 4M5 20h14',
  shield: 'M12 3l7 3v6c0 4-3 7-7 9-4-2-7-5-7-9V6z',
  search: 'm20 20-4.5-4.5',
};

const circles: Partial<Record<IconName, { cx: number; cy: number; r: number }>> = {
  info: { cx: 12, cy: 12, r: 9 },
  user: { cx: 12, cy: 8, r: 4 },
  chat: { cx: 12, cy: 12, r: 9 },
  search: { cx: 11, cy: 11, r: 7 },
};

interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: IconName;
  size?: number;
}

export const Icon = ({ name, size = 24, ...rest }: IconProps) => {
  const circle = circles[name];
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {circle && <circle cx={circle.cx} cy={circle.cy} r={circle.r} />}
      <path d={paths[name]} />
    </svg>
  );
};

